import { getEntityStrategy, LOAD_STRATEGIES } from '../config/reference.config.js';

/**
 * `/reference-data/seed` is only for hybrid entities. Bulk/lazy lists come from
 * GET `/reference-data` (hydrateAll / ensureEntity).
 * @param {string} entityKey
 * @returns {boolean}
 */
export function usesHybridSeedEndpoint(entityKey) {
    return getEntityStrategy(entityKey) === LOAD_STRATEGIES.HYBRID;
}

/**
 * @param {string} entityKey
 * @returns {boolean}
 */
export function usesBulkOrLazyHydration(entityKey) {
    const strategy = getEntityStrategy(entityKey);
    return strategy === LOAD_STRATEGIES.BULK || strategy === LOAD_STRATEGIES.LAZY;
}
